import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../config';
import common from './../common';
import {
    makeLogin,
    initialDetailsCompleted,
    saveUserToken,
    saveUserProfile,
    setGamingHubStatus
} from './../actions/AuthActions';
import { setTotalScore } from './../actions/AppActions';
import {
    postSaveTeam,
} from './../actions/FormationActions';
import {
    resetTeamData,
} from './../actions/ManageTeamActions';

class GamingHubComponent extends Component {
    constructor(props) {
        super(props);
        this.timeout = null;
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    invokePostSaveTeam = () => {
        const GUID = common.getGUID();
        this.props.postSaveTeam(GUID, this.props.defaultFormationIndex, this.props.constraints, this.props.teamData);
    };

    handleLogin(user, userProfile, isAnonymous) {
        common.showLoader();
        const oldUEFASocialID = common.getDataFromCookie('UefaSocialId');
        const UEFASocialID = userProfile['ref_id'] || 0;
        if (oldUEFASocialID && (oldUEFASocialID !== UEFASocialID)) {
            this.props.resetTeamData();
        }
        let obj = {
            UefaSocialId: UEFASocialID,
            ClientId: 1,
            optType: 1,
            SocialId: user['user_id'],
            UserId: user['user_id'],
            FullName: userProfile['username'],
            ProfilePic: userProfile['avatar'].url,
            CountryCode: userProfile['ref_country_code'],
            IsAnonymous: isAnonymous,
            PlatformId: config.PLATFORM_ID,
            access_token: user.access_token
        };
        this.props.makeLogin(obj).then(() => {
            const loginResponse = this.props.loginResponse;
            if (loginResponse && loginResponse.Meta['Success'] && loginResponse.Meta['RetVal'] === 1) {

                if (loginResponse.Data && loginResponse.Data.Value && loginResponse.Data.Value.mUserDetails && loginResponse.Data.Value.mUserDetails.IsGDPRActive) {
                    common.deleteCookie(config.AUTH_COOKIE);
                    common.deleteCookie(config.COOKIE_GM);
                    common.removeLocalStorage('totalScore');
                    common.removeLocalStorage('profile');
                    setTimeout(function () {
                        window.location.href = config.BASE_DOMAIN;
                    }, 500)
                }

                this.props.gamingHubLoaded(true);
                let userToken = window.uefaGHComponent.getUserTokens();
                const userProfile = window.uefaGHComponent.getUserProfile();
                this.props.saveUserToken(userToken);
                this.props.saveUserProfile(userProfile);
                this.props.initialDetailsCompleted(true);
                common.hideLoader();
            } else {
                common.hideLoader();
            }
        });
    }

    checkLoaded = () => {
        const callDetailsAPI = (isInitiallyCalled) => {
            let userToken = window.uefaGHComponent.getUserTokens();
            const userProfile = window.uefaGHComponent.getUserProfile();
            const isAnonymous = userToken.registered === false;
            if (isAnonymous) {
                common.deleteCookie(config.AUTH_COOKIE);
                common.deleteCookie(config.COOKIE_GM);
                common.removeLocalStorage('totalScore');
                common.removeLocalStorage('profile');

                this.props.setTotalScore(null);
                this.props.initialDetailsCompleted(true);
                common.hideLoader();

            } else {
                userToken = isAnonymous ? userToken.anonymous : userToken.registered;
                this.handleLogin(userToken, userProfile, isAnonymous, isInitiallyCalled);
            }
        };
        if (window.uefaGHComponent && window.uefaGHComponent.isLoaded) {

            clearTimeout(this.timeout);
            callDetailsAPI(true);
            window.uefaGHComponent.loadLoginFunction(() => {

                // const isAnonymous = userToken.registered === false;
                if (window.uefaGHComponent.getUserTokens().anonymous) {
                    this.props.gamingHubLoaded(true);
                } else {
                    callDetailsAPI(false);
                }
            });
        } else {
            this.timeout = setTimeout(() => {
                this.checkLoaded();
            }, 300);
        }
    };

    componentDidMount() {
        this.props.gamingHubLoaded(false);
        window.ghComponentLoaded = false;
        this.checkLoaded();
    }

    render() {
        const props = {
            language: config.CURRENT_LANGUAGE,
            game: config.gameName
        };
        return React['createElement']('g-h-c', props);
    }
}

const mapStateToProps = (state) => {
    return {
        loginResponse: state.authData.loginResponse,
        isGamingHubLoaded: state.authData.isGamingHubLoaded,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        makeLogin: (data) => dispatch(makeLogin(data)),
        initialDetailsCompleted: (bool) => dispatch(initialDetailsCompleted(bool)),
        postSaveTeam: (guid, formationsID, constrains, teamData) => dispatch(postSaveTeam(guid, formationsID, constrains, teamData)),
        resetTeamData: () => dispatch(resetTeamData()),
        saveUserToken: (data) => dispatch(saveUserToken(data)),
        saveUserProfile: (data) => dispatch(saveUserProfile(data)),
        setTotalScore: (score) => dispatch(setTotalScore(score)),
        gamingHubLoaded: (bool) => dispatch(setGamingHubStatus(bool))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(GamingHubComponent);


// WEBPACK FOOTER //
// ./src/components/GamingHubComponent.js